import { createApp } from 'vue'
import { createPinia } from 'pinia'

import * as Sentry from "@sentry/vue";

import './style.css'
import App from './App.vue'

// App shared components
import AppLink from './components/shared/AppLink.vue'

import router from '@/router'

const pinia = createPinia()

const app = createApp(App)

// Sentry early initialization
Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: import.meta.env.VITE_ENVIRONMENT,
});

app
    .component('AppLink', AppLink)
    .use(pinia)
    .use(router)
    .mount('#app')
